import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import {
    Box,
    Container,
    Flex,
    Heading,
    LinkBox,
    LinkOverlay
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const CardButton = (props) => {
         
      const item = {
        hidden: { opacity: 0 },
        show: { opacity: 1 },
      }
      
    return (    
      <Box as={motion.div} whileHover={{ scale: 1.05 }}
              w={{base: '100%', lg: '25%'}}
              p="4" cursor="pointer"
              variants={item}
              >
                
              <LinkBox position="relative" as="article">
                <LinkOverlay as={GatsbyLink} to={props.boxLink}>
                  <GatsbyImage image={getImage(props?.photo)} alt={props.alt} aspectRatio={1} imgStyle={{borderRadius: '1rem'}}/>
                  <Box position="absolute" bottom="0" w="100%">
                    <Heading as="h3" color="white" fontSize="6xl" textAlign="center" mb="12">
                        {props.title}
                    </Heading>
                  </Box>
                  </LinkOverlay>
              </LinkBox>
      </Box>
    
  )
}

export default function StayPlayEatSection({ slice }) {
  
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        ease: "easeOut", 
        duration: '0.75',
        staggerChildren: 0.25,
      }
    }
  }

  const stayImage = getImage(slice.items[0].image_1.localFile);
  const playImage = getImage(slice.items[0].image_2.localFile);
  const eatImage = getImage(slice.items[0].image_3.localFile);
  
  let liveImage;

  if (slice.items[0].image_4) {
    liveImage = getImage(slice.items[0].image_4.localFile);
  } else {
    liveImage = null
  }
    return (
      <Box>
        <Box h={{base: 2, lg: 4}} bg="sage.500" />
          <Box bg="blue.500" p="12" as="section">
              <Container maxW="container.lg">
                  <Heading as="h2" fontSize={["4xl", "4xl", "4xl", "4xl", "6xl"]} textAlign="center" color="white" mb="12">
                      {slice.primary.section_title.text}
                  </Heading>
                  <Box>
                      <Flex as={motion.div} w="100%" justifyContent="center" flexWrap="wrap" variants={container} initial="hidden" whileInView="show" viewport={{ once: true }}>
                              <CardButton 
                                  title={slice.items[0].label_1}
                                  photo={stayImage}
                                  boxLink={slice.items[0].link_1.url}
                              />
                              <CardButton 
                                  title={slice.items[0].label_2}
                                  photo={playImage}
                                  boxLink={slice.items[0].link_2.url}
                              />
                              <CardButton 
                                  title={slice.items[0].label_3}
                                  photo={eatImage}
                                  boxLink={slice.items[0].link_3.url}
                              />
                              {liveImage !== null && (
                                <CardButton 
                                title={slice.items[0].label_4}
                                photo={liveImage}
                                boxLink={slice.items[0].link_4.url}
                            />
                              )}
                      </Flex>
                  </Box>
              </Container>
          </Box>
          <Box h={{base: 2, lg: 4}} bg="sage.500" />
      </Box>
    )
}
